(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bank-discount-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var trigger = document.getElementById('bdb-trigger');
  var drawer = document.getElementById('bdb-drawer');
  var banner = document.getElementById('bank-discount-banner');
  if (trigger && drawer) {
    trigger.addEventListener('click', function() {
      var isOpen = !drawer.hidden;
      drawer.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
      banner.classList.toggle('bdb--open', !isOpen);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-trust-urgency"] && !Shopify.designMode) return;
  try {
    
(function () {
  var timerEl = document.getElementById('timer-countdown');
  if (timerEl) {
    function tick() {
      var now = new Date();
      var pkHour = (now.getUTCHours() + 5) % 24;
      var secondsLeft;
      if (pkHour < 17) {
        secondsLeft = (17 - pkHour) * 3600 - now.getMinutes() * 60 - now.getSeconds();
      } else {
        secondsLeft = (24 - pkHour + 17) * 3600 - now.getMinutes() * 60 - now.getSeconds();
      }
      var h = Math.floor(secondsLeft / 3600);
      var m = Math.floor((secondsLeft % 3600) / 60);
      var s = secondsLeft % 60;
      timerEl.textContent = [h, m, s].map(function (n) { return n.toString().padStart(2, '0'); }).join(':');
    }
    tick();
    setInterval(tick, 1000);
  }
  var viewerEl = document.getElementById('viewer-count');
  if (viewerEl) {
    var min = parseInt('{{ section.settings.viewer_count_min }}') || 8;
    var max = parseInt('{{ section.settings.viewer_count_max }}') || 24;
    var current = min + Math.floor(Math.random() * (max - min));
    viewerEl.textContent = current;
    setInterval(function () {
      var delta = Math.random() < 0.5 ? 1 : -1;
      current = Math.max(min, Math.min(max, current + delta));
      viewerEl.textContent = current;
    }, 6000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('sticky-atc');
  var btn = document.getElementById('sticky-atc-btn');
  var threshold = 400;
  var isAdding = false;

  /* ── Show/hide on scroll ── */
  function checkScroll() {
    var show = window.scrollY > threshold;
    if (show && !bar.classList.contains('is-visible')) {
      bar.classList.add('is-visible');
    } else if (!show && bar.classList.contains('is-visible')) {
      bar.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', checkScroll, { passive: true });

  /* ── Sync variant from main product form ── */
  function syncVariant() {
    /* Try input[name="id"] first (most themes) */
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value && btn) {
      btn.setAttribute('data-variant-id', idInput.value);
      return;
    }
    /* Fallback: selected variant pill */
    var checked = document.querySelector('.variant-input-wrapper input:checked');
    if (checked && btn) {
      btn.setAttribute('data-variant-id', checked.value);
    }
  }

  /* Listen for variant changes — covers both select and pill inputs */
  document.addEventListener('change', function (e) {
    if (
      e.target.name === 'id' ||
      e.target.type === 'radio' ||
      e.target.classList.contains('product-form__input')
    ) {
      syncVariant();
    }
  });

  /* Also listen for Shopify's variant:changed custom event */
  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.variant && btn) {
      btn.setAttribute('data-variant-id', e.detail.variant.id);
    }
  });

  /* Initial sync on load */
  document.addEventListener('DOMContentLoaded', syncVariant);
  setTimeout(syncVariant, 500);

  /* ── Add to cart ── */
  if (btn) {
    btn.addEventListener('click', function () {
      if (isAdding) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || variantId === 'null' || variantId === '') return;

      isAdding = true;
      btn.classList.add('loading');
      btn.querySelector('.sticky-atc__btn-text').textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function(err) { throw err; });
        }
        return response.json();
      })
      .then(function (item) {
        /* Success — item was added */
        btn.classList.remove('loading');
        btn.classList.add('added');
        btn.querySelector('.sticky-atc__btn-text').textContent = 'Added ✓';

        /* Update cart count badge — covers Trade theme drawer */
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            /* Update all cart count elements */
            var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart__count, #cart-icon-bubble span');
            countEls.forEach(function(el) {
              el.textContent = cart.item_count;
            });
            /* Fire events that Trade theme listens to */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cart }));

            /* Try to open cart drawer if Trade theme supports it */
            var drawerTrigger = document.querySelector('[data-cart-toggle], cart-drawer, #cart-drawer');
            if (drawerTrigger && typeof drawerTrigger.open === 'function') {
              drawerTrigger.open();
            }
          });

        setTimeout(function () {
          isAdding = false;
          btn.classList.remove('added');
          btn.querySelector('.sticky-atc__btn-text').textContent = 'Add to Cart';
        }, 2500);
      })
      .catch(function (err) {
        /* Failed — reset cleanly */
        isAdding = false;
        btn.classList.remove('loading');
        btn.classList.remove('added');
        btn.querySelector('.sticky-atc__btn-text').textContent = 'Add to Cart';
        console.error('Sticky ATC error:', err);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
